import React from 'react';
import { HowItWorks } from '../components/sections/HowItWorks';

export const HowItWorksPage: React.FC = () => {
  return <HowItWorks />;
};